import React, { FormEvent, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './../../utils/auth-context';
import Input from "../../ui-kit/input/input";
import styles from "./page-login.module.css";

import { BASE_URL } from "./../../api/api-сonfig";
import authorizationSvg from "./../../assets/img/page-login/authorization.svg";

const PageLogin: React.FC = () => {
  const navigate = useNavigate();
  const { token, setToken } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token, navigate]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);

    try {
      const response = await fetch(`${BASE_URL}/wp-json/jwt-auth/v1/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      const data = await response.json();
      if (response.ok && typeof data.token === 'string' && data.token) {
        setToken(data.token);
        navigate('/');
        return;
      }

      setError('Ошибка входа. Пожалуйста, проверьте свое имя пользователя и пароль');
    } catch {
      setError('Не удалось связаться с сервером. Попробуйте ещё раз');
    }
  };

  return (
    <section className={styles.block}>
      <div className="container">
        <div className={styles.block__row}>
          <div className={styles.block__panel}>
            <div className={styles.block__aut}>
              <h1 className={styles.block__title}>Добро пожаловать в <span>Sercons Marketing</span></h1>
              <form className={styles.block__form} onSubmit={handleSubmit}>
                <Input
                  type="text"
                  placeholder="Имя пользователя"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  label="Имя пользователя"
                />
                <Input
                  type="password"
                  placeholder="Ваш пароль"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  label="Пароль"
                />
                <button className={styles.block__btn} type="submit">
                  Войти
                </button>
              </form>
            </div>
            {error && <p className={styles.block__error}>{error}</p>}
          </div>
          <div className={styles.block__picture}>
            <img
              className={styles.block__img}
              src={authorizationSvg}
              alt="авторизация-svg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageLogin;
